import React from "react";

import withStyles from "material-ui/styles/withStyles";
import LoginForm from "./Sections/LoginForm";

import Parallax from "components/Parallax/Parallax.jsx";

import GridContainerHome from "components/Grid/GridContainerHome.jsx";
import GridItemHome from "components/Grid/GridItemHome.jsx";
import Card from "components/Card/Card.jsx";

import componentsStyle from "assets/jss/material-kit-react/views/components.jsx";

class ProjectLoginPage extends React.Component {
  render() {
    const { classes, history } = this.props;
    return (
      <div>
        <Parallax image={require("assets/img/bg8.jpg")}>
          <div className={classes.container}>
          <GridContainerHome justify="center">
                <GridItemHome xs={12} sm={12} md={5}>
                  <div className={classes.brand}>
                      <h1 className={classes.title}>Sign In</h1>
                        <div className={classes.subtitle}>
                          <h5>
                            . . . To see <strong>current projects, connected freelancers at Project SEA </strong>and much more.
                          </h5>
                          <br/>
                          <h5>
                            Join <strong>parties, coaching/mastermind sessions, </strong>and meetings with investors in Bali.
                          </h5>
                        </div>
                    </div>
                    </GridItemHome>
                      <GridItemHome xs={12} sm={12} md={5}>
                        <Card>
                          <LoginForm history={history} />
                        </Card>
                    </GridItemHome>
                </GridContainerHome>
          </div>
        </Parallax>
      </div>
    );
  }
}

export default withStyles(componentsStyle)(ProjectLoginPage);



// WEBPACK FOOTER //
// ./src/views/ProjectLoginPage/ProjectLoginPage.jsx